// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2VTv_","containerItemsCenter":"Skeleton_containerItemsCenter__2fNFI"};